/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const DownSmall: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="down-small" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1224.8075 960.925C1208.955 976.7775 1187.025 986.595 1162.8 986.595S1116.645 976.7775 1100.7925 960.925L680.3825 540.515L259.9725000000001 960.925C244.205 976.14 222.7000000000001 985.5325 199.0275 985.5325C150.5775000000001 985.5325 111.3075 946.2625 111.3075 897.8125C111.3075 874.14 120.7 852.635 135.9575000000001 836.8675000000001L618.375 354.4500000000001C634.2275 338.5975 656.1575 328.78 680.3825 328.78S726.5374999999999 338.5975000000001 742.39 354.4500000000001L1224.8075000000001 836.8675000000001C1240.66 852.72 1250.4775 874.65 1250.4775 898.875S1240.66 945.03 1224.8075000000001 960.8825V960.8825z" : "M979.846 768.74C967.164 781.422 949.62 789.276 930.24 789.276S893.316 781.422 880.634 768.74L544.306 432.4120000000001L207.978 768.74C195.364 780.912 178.16 788.4259999999999 159.222 788.4259999999999C120.462 788.4259999999999 89.046 757.01 89.046 718.25C89.046 699.312 96.56 682.108 108.766 669.494L494.7 283.56C507.382 270.878 524.926 263.024 544.306 263.024S581.23 270.8780000000001 593.912 283.56L979.8460000000002 669.494C992.5280000000002 682.1759999999999 1000.382 699.72 1000.382 719.1S992.528 756.024 979.8460000000002 768.706V768.706z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
DownSmall.displayName = `Blueprint5.Icon.DownSmall`;
export default DownSmall;
